import React, { useEffect, useRef, useState } from "react";
import CoachLayout from "../../layouts/CoachLayout";
import MenuLayout from "../../layouts/MenuLayout";
import { useNavigate, useLocation } from "react-router-dom";
import { coachPaths } from "../../routes/coach";
import BecomeCoachModal from "../../components/pages/coach/become a coach/BecomeCoachModal";

export const BecomeCoach = () => {
  const user = { name: "become-a-coach", role: "coach" };
  const [isModal, setIsModal] = useState(false);
  const [shouldOpenLogin, setShouldOpenLogin] = useState(false);
  const openLoginRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  useEffect(() => {
    if (location?.state?.openLogin) {
      setShouldOpenLogin(true);
    }
  }, [location]);

  useEffect(() => {
    if (!shouldOpenLogin) return;
    const openLogin = openLoginRef.current;
    if (openLogin) {
      openLogin();
      setShouldOpenLogin(false);
    }
  }, [shouldOpenLogin]);

  return (
    <MenuLayout user={user}>
      {({ openLogin }) => {
        openLoginRef.current = openLogin;
        return (
        <>
          <section class="ct_px_40  ct_become_coach_bg">
            <div class="container-fluid">
              <div class="row align-items-center">
                <div
                  class="col-xxl-5 col-xl-5 col-md-5 mb-4 mb-md-0 "
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <div class="ct_boocamp_img_left">
                    <img
                      src="assets/img/become_a_coach_left_img.png"
                      alt=""
                      class="ct_img_h_458 w-100"
                    />
                  </div>
                </div>
                <div
                  class="col-xxl-6 col-xl-7 col-md-7 mb-4 mb-md-0 "
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <div class="ct_px_40 ct_px_0_767">
                    <h2 class="ct_fs_50 mb-4 text-white">
                      Share Your <span class="ct_yellow_text">Expertise</span> ,{" "}
                      <br /> Empower Others, Get Paid
                    </h2>
                    <p class="mb-0 mt-3 ct_fs_20 text-white">
                      Join Nuvio’s growing network of coaches and make a real
                      difference in the lives of founders, teams, and leaders on
                      your own schedule.
                    </p>
                    <div class="ct_mt_40">
                      <a
                        class="ct_yellow_btn  px-5 ct_fit_content ct_h_48"
                        // onClick={(e) => {
                        //   e.preventDefault();
                        //   setIsModal(true);
                        // }}
                        onClick={() => navigate(coachPaths?.ApplyBecomeCoach)}
                        // data-bs-target="#ct_define_path_modal"
                        // data-bs-toggle="modal"
                      >
                        Apply to Become a Coach
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section class="ct_pt_65_pb_58">
            <div class="container">
              <div class="row">
                <div
                  class="col-lg-5 mb-4 mb-lg-0"
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <div class="ct_img_unlock_img_23">
                    <div class="ct_img_unlock_img_23_left">
                      <img src="assets/img/CoachHub_img_1.png" alt="" />
                      <img src="assets/img/CoachHub_img_2.jpg" alt="" />
                    </div>
                    <div class="ct_img_unlock_img_23_right">
                      <img src="assets/img/CoachHub_img_3.jpg" alt="" />
                      <img src="assets/img/CoachHub_img_4.jpg" alt="" />
                    </div>
                  </div>
                </div>
                <div
                  class="col-lg-7 mb-4 mb-lg-0 ps-lg-5"
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <h4 class="ct_fs_32 ct_darkblue_text mb-0">
                    Why Join Nuvio CoachHUB?
                  </h4>
                  <ul className="ct_mt_40">
                    <li>
                      <h4 className="ct_fs_20 mb-2 ct_darkblue_text">
                        Work on Your Terms
                      </h4>
                      <p
                        className="mb-0 ct_darkblue_text"
                        style={{ maxWidth: "496px" }}
                      >
                        Set your own schedule, choose the coaching categories
                        you love, and work with clients who match your values
                        and strengths. Whether you coach part-time or full-time,
                        you’re in control.
                      </p>
                    </li>
                    <li className="mt-4">
                      <h4 className="ct_fs_20 mb-2 ct_darkblue_text">
                        Visibility Without the Hassle
                      </h4>
                      <p
                        className="mb-0 ct_darkblue_text"
                        style={{ maxWidth: "496px" }}
                      >
                        We promote your profile across our entire network from
                        startups and SMEs to leadership teams and creatives so
                        you don’t have to worry about finding clients. You just
                        focus on coaching.
                      </p>
                    </li>
                    <li className="mt-4">
                      <h4 className="ct_fs_20 mb-2 ct_darkblue_text">
                        Opportunities to Expand Your Reach
                      </h4>
                      <p
                        className="mb-0 ct_darkblue_text"
                        style={{ maxWidth: "496px" }}
                      >
                        Want to host a live workshop or sell your own eBook? We
                        give you the platform to do both. Our coaches don’t just
                        coach they teach, lead, and build community.
                      </p>
                    </li>
                    <li className="mt-4">
                      <h4 className="ct_fs_20 mb-2 ct_darkblue_text">
                        Built-In Support
                      </h4>
                      <p
                        className="mb-0 ct_darkblue_text"
                        style={{ maxWidth: "496px" }}
                      >
                        From onboarding to tech setup, we support your success
                        every step of the way. You’re never just “another coach”
                        you’re part of a curated network committed to real
                        impact.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          <section className="ct_we_looking_bg">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <h4 className="ct_fs_32 ct_darkblue_text text-center ct_mb_30">
                    Who We're Looking For
                  </h4>
                </div>
              </div>
              <div className="row align-items-center">
                <div
                  className="col-xxl-7 col-xl-7 col-lg-7 mb-4 mb-lg-0"
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <h4 className="ct_fs_28 mb-4">
                    Experienced Coaches & Industry Experts
                  </h4>
                  <p className="ct_fs_20 mb-4" style={{ maxWidth: "566px" }}>
                    We welcome certified coaches, consultants, and specialists
                    with 10+ years of experience in areas like leadership,
                    business, performance, or personal development.
                  </p>
                  <p className="ct_fs_20 mb-0" style={{ maxWidth: "566px" }}>
                    If you’ve coached clients, led programs, or guided
                    professionals through change, we’d love to see your approach
                    in action.
                  </p>
                </div>
                <div
                  className="col-xxl-5 col-xl-5 col-lg-5 mb-4 mb-lg-0"
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <div>
                    <img
                      src="assets/img/looking_11.png"
                      className="ct_img_h_400"
                    />
                  </div>
                </div>
              </div>
              <div className="row align-items-center ct_mt_60">
                <div
                  className="col-xxl-5 col-xl-5 col-lg-5 mb-4 mb-lg-0"
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <div>
                    <img
                      src="assets/img/looking_22.png"
                      className="ct_img_h_400"
                    />
                  </div>
                </div>
                <div
                  className="col-xxl-7 col-xl-7 col-lg-7 mb-4 mb-lg-0 ps-lg-5"
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <h4 className="ct_fs_28 mb-4">
                    Founders, Executives & Strategic Operators
                  </h4>
                  <p className="ct_fs_20 mb-4" style={{ maxWidth: "540px" }}>
                    You don’t need to be a certified coach just someone who's
                    been there. If you've launched startups, led teams, or
                    shaped strategy at any level, your insight is valuable.
                  </p>
                  <p className="ct_fs_20 mb-0" style={{ maxWidth: "540px" }}>
                    We’re looking for real-world thinkers who can turn
                    experience into guidance and help others lead with
                    confidence.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="ct_px_40 ct_py_130">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12 text-center">
                  <h4 className="ct_fs_32 ct_darkblue_text ct_mb_60">
                    Coaching Categories You Can Join
                  </h4>
                </div>
              </div>
              <div className="row">
                <div
                  className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 ct_mb_50 "
                  data-aos="fade-down"
                  data-aos-duration="1500"
                >
                  <div
                    class="ct_white_bg_card"
                    style={{
                      backgroundColor: "#EDF6F9",
                      borderColor: "#E1E4EA",
                    }}
                  >
                    <div>
                      <div class="ct_icon mb-3">
                        <img
                          src="assets/img/icon-park-solid_arrow-keys.png"
                          alt=""
                        />
                      </div>
                      <div>
                        <h4 class="ct_fs_18 ct_grey_text mb-3">Founder</h4>
                        <p
                          class="mb-0 ct_darkblue_text ct_fs_24_new ct_line_h_40"
                          style={{ maxWidth: "340px" }}
                        >
                          Empowering visionaries to lead with clarity and build
                          with confidence.
                        </p>
                      </div>
                    </div>
                    <div class=" ct_mt_70">
                      <a
                        onClick={() => navigate(coachPaths?.FounderCoaching)}
                        class="ct_yellow_btn  ct_fit_content ct_h_48 ct_outline_yellow_new"
                      >
                        Learn More <i class="fa-solid fa-arrow-right ms-1"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 ct_mb_50"
                  data-aos="fade-down"
                  data-aos-duration="1500"
                >
                  <div
                    class="ct_white_bg_card"
                    style={{
                      backgroundColor: "#FAFAFA",
                      borderColor: "#E1E4EA",
                    }}
                  >
                    <div>
                      <div class="ct_icon mb-3">
                        <img src="assets/img/ion_speedometer.png" alt="" />
                      </div>
                      <div>
                        <h4 class="ct_fs_18 ct_grey_text mb-3">Performance</h4>
                        <p
                          class="mb-0 ct_darkblue_text ct_fs_24_new ct_line_h_40"
                          style={{ maxWidth: "340px" }}
                        >
                          Unlock your full potential and operate at your peak,
                          consistently.
                        </p>
                      </div>
                    </div>
                    <div class=" ct_mt_70">
                      <a
                        onClick={() =>
                          navigate(coachPaths?.PerformanceCoaching)
                        }
                        class="ct_yellow_btn  ct_fit_content ct_h_48 ct_outline_darksky"
                      >
                        Learn More <i class="fa-solid fa-arrow-right ms-1"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 ct_mb_50 "
                  data-aos="fade-down"
                  data-aos-duration="1500"
                >
                  <div
                    class="ct_white_bg_card"
                    style={{
                      backgroundColor: "hsl(199deg 64% 73% / 30%)",
                      borderColor: "hsl(199deg 64% 73% / 30%)",
                    }}
                  >
                    <div>
                      <div class="ct_icon mb-3">
                        <img
                          src="assets/img/material-symbols_mountain-flag_22.png"
                          alt=""
                        />
                      </div>
                      <div>
                        <h4 class="ct_fs_18 ct_grey_text mb-3">Leadership</h4>
                        <p
                          class="mb-0 ct_darkblue_text ct_fs_24_new ct_line_h_40"
                          style={{ maxWidth: "340px" }}
                        >
                          Develop the mindset and presence to lead with impact
                          and purpose.
                        </p>
                      </div>
                    </div>
                    <div class=" ct_mt_70">
                      <a
                        onClick={() => navigate(coachPaths?.LeadershipCoaching)}
                        class="ct_yellow_btn  ct_fit_content ct_h_48 ct_outline_yellow"
                      >
                        Learn More <i class="fa-solid fa-arrow-right ms-1"></i>
                      </a>
                    </div>
                  </div>
                </div>

                <div
                  className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 ct_mb_50 "
                  data-aos="fade-down"
                  data-aos-duration="1500"
                >
                  <div
                    class="ct_white_bg_card"
                    style={{
                      backgroundColor: "hsl(42.86deg 100% 50.59% / 30%)",
                      borderColor: "hsl(199deg 64% 73% / 30%)",
                    }}
                  >
                    <div>
                      <div class="ct_icon mb-3">
                        <img
                          src="assets/img/icon-park-solid_arrow-keys_4.png"
                          alt=""
                        />
                      </div>
                      <div>
                        <h4 class="ct_fs_18 ct_grey_text mb-3">Team</h4>
                        <p
                          class="mb-0 ct_darkblue_text ct_fs_24_new ct_line_h_40"
                          style={{ maxWidth: "340px" }}
                        >
                          Foster collaboration, communication, and cohesion for
                          stronger results.
                        </p>
                      </div>
                    </div>
                    <div class=" ct_mt_70">
                      <a
                        onClick={() => navigate(coachPaths?.TeamTeaching)}
                        class="ct_yellow_btn  ct_fit_content ct_h_48 ct_outline_yellow"
                      >
                        Learn More <i class="fa-solid fa-arrow-right ms-1"></i>
                      </a>
                    </div>
                  </div>
                </div>

                <div
                  className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 ct_mb_50 "
                  data-aos="fade-down"
                  data-aos-duration="1500"
                >
                  <div
                    class="ct_white_bg_card"
                    style={{
                      backgroundColor: "hsl(43deg 100% 51% / 10%)",
                      borderColor: "hsl(199deg 64% 73% / 30%)",
                    }}
                  >
                    <div>
                      <div class="ct_icon mb-3">
                        <img src="assets/img/Icon_business.png" alt="" />
                      </div>
                      <div>
                        <h4 class="ct_fs_18 ct_grey_text mb-3">Business</h4>
                        <p
                          class="mb-0 ct_darkblue_text ct_fs_24_new ct_line_h_40"
                          style={{ maxWidth: "332px" }}
                        >
                          Sharpen your business direction with expert guidance
                          and insight.
                        </p>
                      </div>
                    </div>
                    <div class=" ct_mt_70">
                      <a
                        onClick={() => navigate(coachPaths?.BusinessCoaching)}
                        class="ct_yellow_btn  ct_fit_content ct_h_48 ct_outline_yellow"
                      >
                        Learn More <i class="fa-solid fa-arrow-right ms-1"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 ct_mb_50 "
                  data-aos="fade-down"
                  data-aos-duration="1500"
                >
                  <div
                    class="ct_white_bg_card"
                    style={{
                      backgroundColor: "#F5F3EF",
                      borderColor: "hsl(199deg 64% 73% / 30%)",
                    }}
                  >
                    <div>
                      <div class="ct_icon mb-3">
                        <img src="assets/img/ph_person-fill.png" alt="" />
                      </div>
                      <div>
                        <h4 class="ct_fs_18 ct_grey_text mb-3">Personal</h4>
                        <p
                          class="mb-0 ct_darkblue_text ct_fs_24_new ct_line_h_40"
                          style={{ maxWidth: "332px" }}
                        >
                          Gain clarity, confidence, and control over your
                          personal growth journey.
                        </p>
                      </div>
                    </div>
                    <div class=" ct_mt_70">
                      <a
                        onClick={() => navigate(coachPaths?.PersonalCoaching)}
                        class="ct_yellow_btn  ct_fit_content ct_h_48 ct_outline_darksky"
                      >
                        Learn More <i class="fa-solid fa-arrow-right ms-1"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section class="ct_pb_100 ct_px_40 pt-0">
            <div class="container-fluid">
              <div class="row align-items-center">
                <div
                  class="col-lg-3 mb-4 mb-lg-0 aos-init aos-animate"
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <div class="ct_how_work_img">
                    <img src="assets/img/apply_left_img.png" alt="" />
                  </div>
                </div>
                <div
                  class="col-lg-9 mb-4 mb-lg-0 ps-lg-5"
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <div class="ct_how_work_content">
                    <h4 class="ct_fs_24">How to Join ?</h4>
                    <h3 class="ct_fs_32 ">Apply. Align. Start Coaching</h3>
                  </div>
                  <div class="row mt-5">
                    <div class="col-lg-4 col-md-6">
                      <div class="ct_how_work_card p-4">
                        <img
                          src="assets/img/Apply_icon_1.png"
                          alt=""
                          className="ct_w_50_330"
                        />
                        <div class="pt-4">
                          <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                            Submit Your Application
                          </h5>
                          <p
                            class="mb-0 ct_fs_16"
                            style={{ maxWidth: "257px" }}
                          >
                            Share your background and focus area.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-6">
                      <div class="ct_how_work_card p-4">
                        <img
                          src="assets/img/Apply_icon_2.png"
                          alt=""
                          className="ct_w_50_340"
                        />
                        <div class="pt-4">
                          <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                            Interview / Review Stage
                          </h5>
                          <p
                            class="mb-0 ct_fs_16"
                            style={{ maxWidth: "257px" }}
                          >
                            We’ll reach out if your experience fits our value.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-6">
                      <div class="ct_how_work_card p-4">
                        <img
                          src="assets/img/Apply_icon_3.png"
                          alt=""
                          className="ct_w_50_330"
                        />
                        <div class="pt-4">
                          <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                            Get Onboarded
                          </h5>
                          <p
                            class="mb-0 ct_fs_16"
                            style={{ maxWidth: "257px" }}
                          >
                            Create your profile and start accepting bookings.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section
            class="ct_looking_for_work_bg ct_looking_for_work_bg_left   ct_dark_sky_bg ct_p_111_y_106"
            data-aos="fade-down"
            data-aos-duration="1500"
          >
            <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
              <div class="text-white">
                <h4 class="ct_fs_36 mb-4" style={{ maxWidth: "500px" }}>
                  Ready to Make an Impact?
                </h4>
                <p class="mb-0 ct_fs_18" style={{ maxWidth: "700px;" }}>
                  Join a network of passionate coaches shaping the future of
                  personal and professional growth.
                </p>
              </div>
              <div class="ct_flex_shrink_0">
                <a
                  onClick={() => navigate(coachPaths.ApplyBecomeCoach)}
                  // data-bs-target="#ct_define_path_modal"
                  // data-bs-toggle="modal"
                  class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
                >
                  Start Your Application
                </a>
              </div>
            </div>
          </section>

          <section class=" ct_px_40 pt-0 ct_mt_100">
            <div class="container-fluid">
              <div class="row align-items-center">
                <div
                  class="col-xxl-6 col-xl-6 col-md-6 mb-4 mb-md-0"
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <div class="ct_about_cnt">
                    <h2 class=" ct_fs_32  ct_mb_60">
                      Frequently asked questions
                    </h2>

                    <div class="ct_faq_question_main">
                      <div class="accordion" id="faq_accordionExample">
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="faq_one">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapsefaq_one"
                              aria-expanded="false"
                              aria-controls="collapsefaq_one"
                            >
                              How can I become a coach on NUVIO?
                            </button>
                          </h2>
                          <div
                            id="collapsefaq_one"
                            class="accordion-collapse collapse"
                            aria-labelledby="faq_one"
                            data-bs-parent="#faq_accordionExample"
                          >
                            <div class="accordion-body">
                              <p class="ct_fs_20 mb-0 ct_line_h_30">
                                To become a coach on NUVIO, simply apply through
                                our platform by creating a coach profile and
                                submitting your expertise, experience, and the
                                type of coaching you offer. Our team will review
                                your application and get back to you once it’s
                                approved.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="faqtwo">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapsefaq_Two"
                              aria-expanded="true"
                              aria-controls="collapseTwo"
                            >
                              What kind of content can I offer as a coach?
                            </button>
                          </h2>
                          <div
                            id="collapsefaq_Two"
                            class="accordion-collapse collapse "
                            aria-labelledby="faqtwo"
                            data-bs-parent="#faq_accordionExample"
                          >
                            <div class="accordion-body">
                              <p class="ct_fs_20 mb-3 ct_line_h_30">
                                You can offer a wide range of content such as
                                1:1 coaching sessions, group sessions,
                                workshops, webinars, mentorship programs,
                                downloadable resources, and educational content
                                related to your field of expertise.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="faqthree">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapsefaq_Three"
                              aria-expanded="false"
                              aria-controls="collapsefaq_Three"
                            >
                              Do I need to handle the marketing myself?
                            </button>
                          </h2>
                          <div
                            id="collapsefaq_Three"
                            class="accordion-collapse collapse"
                            aria-labelledby="faqthree"
                            data-bs-parent="#faq_accordionExample"
                          >
                            <div class="accordion-body">
                              <p class="ct_fs_20 mb-3 ct_line_h_30">
                                No, you don’t have to manage everything alone.
                                NUVIO supports you with visibility on the
                                platform and promotional opportunities. However,
                                you’re also free to promote your services on
                                your own channels if you wish.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="faqFour">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapsefaq_Four"
                              aria-expanded="false"
                              aria-controls="collapsefaq_Four"
                            >
                              Who will see my content or sessions?
                            </button>
                          </h2>
                          <div
                            id="collapsefaq_Four"
                            class="accordion-collapse collapse"
                            aria-labelledby="faqFour"
                            data-bs-parent="#faq_accordionExample"
                          >
                            <div class="accordion-body">
                              <p class="ct_fs_20 mb-0 ct_line_h_30">
                                Your content and sessions will be visible to
                                NUVIO’s community, including users, freelancers,
                                entrepreneurs, and businesses looking for
                                coaching support in your area of expertise.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="faqFive">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapsefaq_Five"
                              aria-expanded="false"
                              aria-controls="collapsefaq_Five"
                            >
                              How do I earn from my sessions or content?
                            </button>
                          </h2>
                          <div
                            id="collapsefaq_Five"
                            class="accordion-collapse collapse"
                            aria-labelledby="faqFive"
                            data-bs-parent="#faq_accordionExample"
                          >
                            <div class="accordion-body">
                              <p class="ct_fs_20 mb-3 ct_line_h_30">
                                You earn directly from the sessions, programs,
                                or content you sell on the platform. NUVIO
                                provides the infrastructure to host, promote,
                                and manage bookings, making it easier for you to
                                focus on delivering value.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="col-xxl-5  col-xl-6 col-md-6 mb-4 mb-md-0 ps-xl-5 "
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <div class="ct_about_img">
                    <img
                      src="assets/img/faq_become_as_coach.png"
                      class="ct_img_h_617"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section
            class="ct_looking_for_work_bg  ct_mt_100"
            data-aos="fade-down"
            data-aos-duration="1500"
          >
            <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
              <div class="text-white">
                <h4 class="ct_fs_36 mb-3" style={{ maxWidth: "700px" }}>
                  Ready to Learn Something That Actually Moves the Needle?
                </h4>
                <p class="mb-0 ct_fs_18" style={{ maxWidth: "623px" }}>
                  Join a live session, get real-time support, and walk away with
                  tools you can apply today- not someday.
                </p>
              </div>
              <div class="ct_flex_shrink_0">
                <a
                  class="ct_yellow_btn ct_darkblue_btn ct_flex_1"
                  // data-bs-target="#ct_onboarding_main"
                  // data-bs-toggle="modal"
                  onClick={() => navigate(coachPaths?.FindCoach)}
                >
                  View Coaches
                </a>
              </div>
            </div>
          </section>
          {/* 
      <footer class="ct_px_40 py-5">
        <div class="ct_footer_logo">
          <a>
            <img src="assets/img/Nuvio_logo.png" alt="" />
          </a>
        </div>
        <div class="row pt-4">
          <div class="col-xxl-3 col-xl-2 col-md-6 mb-4">
            <div class="ct_footer_links">
              <h4 class="ct_fs_20 ct_darkblue_text mb-3">Navigation</h4>
              <ul>
                <li>
                  <a>For Enterprises</a>
                </li>
                <li>
                  <a>For Freelancers</a>
                </li>
                <li>
                  <a>CoachHUB</a>
                </li>
                <li>
                  <a>Funding</a>
                </li>
                <li>
                  <a>About us</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-xxl-3 col-xl-2 col-md-6 mb-4">
            <div class="ct_footer_links">
              <h4 class="ct_fs_20 ct_darkblue_text mb-3">Resources</h4>
              <ul>
                <li>
                  <a>Blog</a>
                </li>
                <li>
                  <a>Newsletter</a>
                </li>
                <li>
                  <a>Tutorials</a>
                </li>
                <li>
                  <a>Support</a>
                </li>
                <li>
                  <a>Help Centre</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-xxl-2 col-xl-3 col-md-6 mb-4">
            <div class="ct_footer_links">
              <h4 class="ct_fs_20 ct_darkblue_text mb-3">Get in Touch</h4>
              <ul>
                <li>
                  <a href="mailto:hello@nu-vio.com">
                    <i class="fa-solid fa-envelope me-1 ct_yellow_text"></i>
                    hello@nu-vio.com
                  </a>
                </li>
                <li>
                  <a href="tel:+123-456-789">
                    <i class="fa-solid fa-phone me-1 ct_yellow_text"></i>
                    +123-456-789
                  </a>
                </li>
                <li>
                  <a>
                    <i class="fa-solid fa-location-dot ct_yellow_text me-1"></i>{" "}
                   Office 36, 1 Exchange Building (TBE), Cybercity, Ebene Mauritius
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-xxl-4 col-xl-5 col-md-6 mb-4">
            <div class="ct_newsletter_bg">
              <p>Ready to keep up with what’s next?</p>
              <div class="d-flex align-items-center gap-2 justify-content-between ct_flex_col_991">
                <div class="form-group ct_flex_1 ct_w_100_991">
                  <input
                    type="email"
                    class="form-control ct_input ct_border_radius_100"
                    placeholder="Enter your email address"
                  />
                </div>
                <div class="ct_w_100_991">
                  <button class="ct_yellow_btn ct_darkblue_btn ct_border_radius_100 ct_h_48 ct_w_100_991">
                    Subscribe now
                  </button>
                </div>
              </div>
            </div>
            <div class="pt-4">
              <h5 class="ct_fs_18 mb-3">Follow Us</h5>
              <div class="d-flex align-items-center gap-2">
                <a style={{ color: "#0076B2" }}>
                  <i class="fa-brands fa-linkedin"></i>
                </a>
                <a style={{ color: "#3D5A98" }}>
                  <i class="fa-brands fa-square-facebook"></i>
                </a>
                <a style={{ color: "#FF0000" }}>
                  <i class="fa-brands fa-youtube"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="row pt-4 ct_border_top_1">
          <div class="col-md-12">
            <p class="mb-0 text-center">
              Copyright @ 2025 NUVIO All Rights Reserved
            </p>
          </div>
        </div>
      </footer> */}

          {isModal && (
            <BecomeCoachModal isOpen={isModal} setClose={setIsModal} />
          )}
          {/*  setup_signature_modal modal  S */}
          {/* <div
        class="modal fade ct_large_modal_width   "
        id="setup_signature_modal"
        tabindex="-1"
        aria-labelledby="setup_signature_modalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header border-0 p-0 pb-2">
              <div
                className="ct_back_top_btn"
                data-bs-target="#ct_define_path_modal"
                data-bs-toggle="modal"
              >
                <i class="fa-solid fa-arrow-left"></i>
              </div>
              <button
                type="button"
                class="btn-close ct_close_position_right12"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body pe-0">
              <section class="ct_signup_main py-3">
                <div class="container-fluid">
                  <div class="row align-items-center">
                    <div class="col-xxl-4 col-xl-4 col-lg-4 mb-4 mb-lg-0 d-none d-lg-block">
                      <div class="ct_signup_left_img">
                        <img
                          src="../assets/img/coach_step_2_img.png"
                          alt=""
                          style={{ objectFit: "cover" }}
                        />
                      </div>
                    </div>
                    <div class="col-xxl-8 col-xl-8 col-lg-8 mb-4 mb-lg-0 mx-auto pe-0">
                      <div class="ct_signup_right_content px-5 ct_custom_scroll">
                        <div class="ct_signup_logo ct_mb_30">
                          <img src="../assets/img/Nuvio_logo.png" alt="" />
                        </div>
                        <div class="mt-0 text-center">
                          <h2 class="ct_fs_32  mb-3 ct_darkblue_text">
                            Set Up Your Signature Offer
                          </h2>
                          <p
                            class="mb-0 ct_darkblue_text mx-auto"
                            style={{ maxWidth: "579px" }}
                          >
                            Define what your coaching includes, how much it
                            costs, and how sessions are delivered
                          </p>
                        </div>
                        <form action="" class="ct_mt_40">
                          <div class="row">
                            <div class="col-md-12">
                              <div class="form-group mb-4">
                                <label
                                  for=""
                                  class="mb-2 d-block ct_darkblue_text ct_fs_14"
                                >
                                  {" "}
                                  Name your Offer{" "}
                                </label>
                                <input
                                  type="text"
                                  class="form-control ct_input"
                                  placeholder="Name your offer "
                                />
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group mb-4">
                                <label
                                  for=""
                                  class="mb-2 d-block ct_darkblue_text ct_fs_14"
                                >
                                  Pricing
                                </label>
                                <input
                                  type="number"
                                  class="form-control ct_input"
                                  placeholder="Pricing "
                                />
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group mb-4">
                                <label
                                  for=""
                                  class="mb-2 d-block ct_darkblue_text ct_fs_14"
                                >
                                  Session Duration
                                </label>
                                <input
                                  type="date"
                                  class="form-control ct_input"
                                />
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group mb-4">
                                <label
                                  for=""
                                  class="mb-2 d-block ct_darkblue_text ct_fs_14"
                                >
                                  Delivery Method
                                </label>
                                <input
                                  type="text"
                                  class="form-control ct_input"
                                  placeholder="Delivery method"
                                />
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group mb-4">
                                <label
                                  for=""
                                  class="mb-2 d-block ct_darkblue_text ct_fs_14"
                                >
                                  Availability
                                </label>
                                <input
                                  type="text"
                                  class="form-control ct_input"
                                  placeholder="Availability"
                                />
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="form-group mb-4">
                                <label
                                  for=""
                                  class="mb-2 d-block ct_darkblue_text ct_fs_14"
                                >
                                  Coaching Style
                                </label>
                                <input
                                  type="text"
                                  class="form-control ct_input"
                                  placeholder="Coaching Style"
                                />
                              </div>
                            </div>
                          </div>

                          <div class="text-center ct_mt_56">
                            <a
                              data-bs-target="#ct_who_are_you_modal_main"
                              data-bs-toggle="modal"
                              class="ct_yellow_btn w-100"
                            >
                              Continue{" "}
                            </a>
                          </div>

                          <div class="ct_step_slider_dots ct_mt_46">
                            <span></span>
                            <span></span>
                            <span class="active"></span>
                            <span></span>
                            <span></span>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div> */}
          {/*  setup_signature_modal modal  E */}

          {/*  ct_who_are_you_modal_main modal  S */}
          {/* <div
        class="modal fade ct_large_modal_width   "
        id="ct_who_are_you_modal_main"
        tabindex="-1"
        aria-labelledby="ct_who_are_you_modal_mainLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header border-0 p-0 pb-2">
              <div
                className="ct_back_top_btn"
                data-bs-target="#setup_signature_modal"
                data-bs-toggle="modal"
              >
                <i class="fa-solid fa-arrow-left"></i>
              </div>
              <div
                className="ct_back_top_btn"
                data-bs-target="#setup_signature_modal"
                data-bs-toggle="modal"
              >
                <i class="fa-solid fa-arrow-left"></i>
              </div>
              <button
                type="button"
                class="btn-close ct_close_position_right12"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body pe-0">
              <section class="ct_signup_main py-3">
                <div class="container-fluid">
                  <div class="row align-items-center">
                    <div class="col-xxl-4 col-xl-4 col-lg-4 mb-4 mb-lg-0 d-none d-lg-block">
                      <div class="ct_signup_left_img">
                        <img
                          src="../assets/img/coach_step_33_img.png"
                          alt=""
                          style={{ objectFit: "cover" }}
                        />
                      </div>
                    </div>
                    <div class="col-xxl-8 col-xl-8 col-lg-8 mb-4 mb-lg-0 mx-auto pe-0">
                      <div class="ct_signup_right_content px-5 ct_custom_scroll">
                        <div class="ct_signup_logo ct_mb_21">
                          <img src="../assets/img/Nuvio_logo.png" alt="" />
                        </div>
                        <div class="mt-0 text-center">
                          <h2 class="ct_fs_32  mb-3 ct_darkblue_text">
                            Who You Are
                          </h2>
                          <p class="mb-0 ct_darkblue_text">
                            Add your photo, bio, tagline, and coaching style to
                            build trust and attract the right clients.
                          </p>
                        </div>
                        <form action="" class="ct_mt_40">
                          <div class="row">
                            <div class="col-md-12">
                              <div class="form-group mb-4">
                                <label
                                  for=""
                                  class="mb-2 d-block ct_darkblue_text ct_fs_14"
                                >
                                  Taglines
                                </label>
                                <input
                                  type="text"
                                  class="form-control ct_input"
                                  placeholder="short and impactful  "
                                />
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="form-group mb-4">
                                <label
                                  for=""
                                  class="mb-2 d-block ct_darkblue_text ct_fs_14"
                                >
                                  {" "}
                                  Profile Photo{" "}
                                </label>
                                <div class="ct_upload_product_main ct_upload_product_main_180 ">
                                  <label for="ct_upload_product">
                                    <p class="text-center ct_fs_18 ct_text_op_07 mb-0 ct_cursor_pointer">
                                      <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M11 9.00025V15.0002C11.0003 15.2551 11.0979 15.5003 11.2728 15.6856C11.4478 15.871 11.687 15.9825 11.9414 15.9974C12.1958 16.0124 12.4464 15.9296 12.6418 15.766C12.8373 15.6024 12.9629 15.3703 12.993 15.1172L13 15.0002V9.00025H19C19.5046 9.00009 19.9906 9.19066 20.3605 9.53375C20.7305 9.87684 20.9572 10.3471 20.995 10.8502L21 11.0002V20.0002C21.0002 20.5048 20.8096 20.9908 20.4665 21.3608C20.1234 21.7308 19.6532 21.9574 19.15 21.9953L19 22.0002H5C4.49542 22.0004 4.00943 21.8098 3.63945 21.4668C3.26947 21.1237 3.04284 20.6534 3.005 20.1502L3 20.0002V11.0002C2.99984 10.4957 3.19041 10.0097 3.5335 9.6397C3.87659 9.26972 4.34684 9.04309 4.85 9.00525L5 9.00025H11ZM12.884 2.46925L16.243 5.82725C16.4306 6.01489 16.5361 6.26938 16.5361 6.53475C16.5361 6.80011 16.4306 7.05461 16.243 7.24225C16.0554 7.42989 15.8009 7.53531 15.5355 7.53531C15.2701 7.53531 15.0156 7.42989 14.828 7.24225L13 5.41325V9.00025H11V5.41325L9.172 7.24225C9.07909 7.33516 8.96879 7.40886 8.8474 7.45914C8.726 7.50942 8.5959 7.53531 8.4645 7.53531C8.33311 7.53531 8.203 7.50942 8.0816 7.45914C7.96021 7.40886 7.84991 7.33516 7.757 7.24225C7.66409 7.14934 7.59039 7.03904 7.54011 6.91764C7.48982 6.79625 7.46394 6.66614 7.46394 6.53475C7.46394 6.40335 7.48982 6.27325 7.54011 6.15185C7.59039 6.03046 7.66409 5.92016 7.757 5.82725L11.117 2.46925C11.3514 2.23506 11.6692 2.10352 12.0005 2.10352C12.3318 2.10352 12.6496 2.23506 12.884 2.46925Z"
                                          fill="#023047"
                                        ></path>
                                      </svg>
                                      Upload Profile
                                    </p>

                                    <input
                                      type="file"
                                      name=""
                                      id="ct_upload_product"
                                      class="d-none"
                                    />
                                  </label>
                                </div>

                                <div class="ct_single_uploaded_img mt-3 d-none">
                                  <img
                                    src="../assets/img/coach_signup_img.png"
                                    alt=""
                                  />
                                  <i class="fa-solid fa-xmark"></i>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="form-group mb-4">
                                <label
                                  for=""
                                  class="mb-2 d-block ct_darkblue_text ct_fs_14"
                                >
                                  Video{" "}
                                </label>
                                <div class="ct_upload_product_main ct_upload_product_main_180 ">
                                  <label for="ct_upload_product">
                                    <p class="text-center ct_fs_18 ct_text_op_07 mb-0 ct_cursor_pointer">
                                      <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M11 9.00025V15.0002C11.0003 15.2551 11.0979 15.5003 11.2728 15.6856C11.4478 15.871 11.687 15.9825 11.9414 15.9974C12.1958 16.0124 12.4464 15.9296 12.6418 15.766C12.8373 15.6024 12.9629 15.3703 12.993 15.1172L13 15.0002V9.00025H19C19.5046 9.00009 19.9906 9.19066 20.3605 9.53375C20.7305 9.87684 20.9572 10.3471 20.995 10.8502L21 11.0002V20.0002C21.0002 20.5048 20.8096 20.9908 20.4665 21.3608C20.1234 21.7308 19.6532 21.9574 19.15 21.9953L19 22.0002H5C4.49542 22.0004 4.00943 21.8098 3.63945 21.4668C3.26947 21.1237 3.04284 20.6534 3.005 20.1502L3 20.0002V11.0002C2.99984 10.4957 3.19041 10.0097 3.5335 9.6397C3.87659 9.26972 4.34684 9.04309 4.85 9.00525L5 9.00025H11ZM12.884 2.46925L16.243 5.82725C16.4306 6.01489 16.5361 6.26938 16.5361 6.53475C16.5361 6.80011 16.4306 7.05461 16.243 7.24225C16.0554 7.42989 15.8009 7.53531 15.5355 7.53531C15.2701 7.53531 15.0156 7.42989 14.828 7.24225L13 5.41325V9.00025H11V5.41325L9.172 7.24225C9.07909 7.33516 8.96879 7.40886 8.8474 7.45914C8.726 7.50942 8.5959 7.53531 8.4645 7.53531C8.33311 7.53531 8.203 7.50942 8.0816 7.45914C7.96021 7.40886 7.84991 7.33516 7.757 7.24225C7.66409 7.14934 7.59039 7.03904 7.54011 6.91764C7.48982 6.79625 7.46394 6.66614 7.46394 6.53475C7.46394 6.40335 7.48982 6.27325 7.54011 6.15185C7.59039 6.03046 7.66409 5.92016 7.757 5.82725L11.117 2.46925C11.3514 2.23506 11.6692 2.10352 12.0005 2.10352C12.3318 2.10352 12.6496 2.23506 12.884 2.46925Z"
                                          fill="#023047"
                                        ></path>
                                      </svg>
                                      Upload Video
                                    </p>

                                    <input
                                      type="file"
                                      name=""
                                      id="ct_upload_product"
                                      class="d-none"
                                    />
                                  </label>
                                </div>

                                <div class="ct_single_uploaded_img mt-3 d-none">
                                  <img
                                    src="../assets/img/coach_signup_img.png"
                                    alt=""
                                  />
                                  <i class="fa-solid fa-xmark"></i>
                                </div>
                              </div>
                            </div>

                            <div class="col-md-12">
                              <div class="form-group mb-4">
                                <label
                                  for=""
                                  class="mb-2 d-block ct_darkblue_text"
                                >
                                  Bio
                                </label>
                                <textarea
                                  class="form-control ct_input h-auto"
                                  rows="3"
                                ></textarea>
                              </div>
                            </div>
                          </div>

                          <div class="text-center mt-4">
                            <a
                              data-bs-dismiss="modal"
                              onClick={() =>
                                navigate(coachPaths?.CoachSubscription)
                              }
                              class="ct_yellow_btn w-100"
                            >
                              Continue{" "}
                            </a>
                          </div>

                          <div class="ct_step_slider_dots">
                            <span></span>
                            <span></span>
                            <span></span>
                            <span class="active"></span>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div> */}
          {/*  ct_who_are_you_modal_main modal  E */}

          {/*  ct_login_modal modal  S */}
          {/* <div
        class="modal fade ct_large_modal_width   "
        id="ct_login_modal"
        tabindex="-1"
        aria-labelledby="ct_login_modalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header border-0 p-0 pb-2">
              <button
                type="button"
                class="btn-close ct_close_position_right12"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body pe-0">
              <section class="ct_signup_main py-3">
                <div class="container-fluid">
                  <div class="row align-items-center">
                    <div class="col-xxl-4 col-xl-5 col-lg-5 mb-4 mb-lg-0 d-none d-lg-block">
                      <div class="ct_signup_left_img">
                        <img src="../assets/img/login_coach.png" alt="" />
                      </div>
                    </div>
                    <div class="col-xxl-8 col-xl-7 col-lg-7 mb-4 mb-lg-0 mx-auto pe-0">
                      <div class="ct_signup_right_content px-3 ct_custom_scroll">
                        <div class="ct_signup_logo mb-3">
                          <img src="../assets/img/Nuvio_logo.png" alt="" />
                        </div>
                        <div class="mt-0 text-center">
                          <h2 class="ct_fs_32  mb-0 ct_darkblue_text">
                            Welcome Back!
                          </h2>
                        </div>
                        <form action="coach-step-1.html" class="mt-4">
                          <div class="row">
                            <div class="col-md-12">
                              <div class="form-group mb-4">
                                <label
                                  for=""
                                  class="mb-2 d-block ct_darkblue_text"
                                >
                                  Email
                                </label>
                                <input
                                  type="text"
                                  class="form-control ct_input"
                                  placeholder="Email"
                                />
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="form-group mb-3">
                                <label
                                  for=""
                                  class="mb-2 d-block ct_darkblue_text"
                                >
                                  Password
                                </label>
                                <div class="position-relative">
                                  <input
                                    type="text"
                                    class="form-control ct_input pe-5"
                                    placeholder="Password"
                                  />
                                  <i class="fa-solid fa-eye ct_show_eye"></i>
                                </div>
                              </div>
                            </div>
                            <div class="text-end">
                              <a
                                data-bs-target="#ct_forgot_pass_modal"
                                data-bs-toggle="modal"
                                class="ct_yellow_text"
                              >
                                Forgot Password?
                              </a>
                            </div>
                          </div>

                          <div class="text-center mt-4">
                            <a
                              data-bs-target="#ct_define_path_modal"
                              data-bs-toggle="modal"
                              class="ct_yellow_btn w-100"
                            >
                              Log In
                            </a>
                          </div>
                        </form>
                        <div class=" text-center mt-3 ct_darkblue_text">
                          Don’t have an account?{" "}
                          <a
                            data-bs-target="#ct_signup_modal_main"
                            data-bs-toggle="modal"
                            class="ct_orange_text"
                          >
                            {" "}
                            Sign Up
                          </a>
                        </div>
                        <div class="ct_or_overlay_text mt-3">
                          <p class="mb-0">Or</p>
                        </div>
                        <div class="d-flex align-items-center justify-content-center gap-3 mt-3 flex-wrap">
                          <button class="ct_grey_btn">
                            <img
                              src="../assets/img/devicon_google.png"
                              alt=""
                            />
                            Sign up with Google
                          </button>
                          <button class="ct_grey_btn">
                            <img src="../assets/img/apple.png" />
                            Sign up with Apple
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div> */}
          {/*  ct_login_modal modal  E */}

          {/*  ct_forgot_pass_modal modal  S */}
          {/* <div
        class="modal fade ct_large_modal_width   "
        id="ct_forgot_pass_modal"
        tabindex="-1"
        aria-labelledby="ct_forgot_pass_modalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header border-0 p-0 pb-2">
              <button
                type="button"
                class="btn-close ct_close_position_right12"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body pe-0">
              <section class="ct_signup_main py-3">
                <div class="container-fluid">
                  <div class="row align-items-center">
                    <div class="col-xxl-4 col-xl-4 col-lg-4 mb-4 mb-lg-0 d-none d-lg-block">
                      <div class="ct_signup_left_img">
                        <img src="../assets/img/login_coach.png" alt="" />
                      </div>
                    </div>
                    <div class="col-xxl-8 col-xl-8 col-lg-8 mb-4 mb-lg-0 mx-auto pe-0">
                      <div class="ct_signup_right_content px-5 ct_custom_scroll">
                        <div class="ct_signup_logo mb-3">
                          <img src="../assets/img/Nuvio_logo.png" alt="" />
                        </div>
                        <div class="mt-0 ">
                          <h2 class="ct_fs_32  mb-2 ct_darkblue_text text-center">
                            Forgot Password
                          </h2>
                          <p
                            class="mb-0 ct_darkblue_text mx-auto"
                            style={{ maxWidth: "454px" }}
                          >
                            No worries, we'll send you instructions to reset
                            your password shortly
                          </p>
                        </div>
                        <form action="" class="mt-4">
                          <div class="row">
                            <div class="col-md-12">
                              <div class="form-group mb-4">
                                <label
                                  for=""
                                  class="mb-2 d-block ct_darkblue_text"
                                >
                                  {" "}
                                  Email
                                </label>
                                <input
                                  type="text"
                                  class="form-control ct_input"
                                  placeholder="Enter your email"
                                />
                              </div>
                            </div>
                          </div>

                          <div class="text-center mt-4">
                            <a
                              data-bs-target="#ct_reset_pass_modal_modal"
                              data-bs-toggle="modal"
                              class="ct_yellow_btn w-100"
                            >
                              Reset Password{" "}
                            </a>
                          </div>
                        </form>
                        <div class="ct_back_login_text text-center mt-3">
                          <a
                            data-bs-target="#ct_login_modal"
                            data-bs-toggle="modal"
                            class="mb-0 ct_darkblue_text"
                          >
                            <i class="fa-solid fa-arrow-left"></i> Back to Log
                            in
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div> */}
          {/*  ct_forgot_pass_modal modal  E */}

          {/*  ct_reset_pass_modal_modal modal  S */}
          <div
            class="modal fade ct_large_modal_width   "
            id="ct_reset_pass_modal_modal"
            tabindex="-1"
            aria-labelledby="ct_reset_pass_modal_modalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header border-0 p-0 pb-2">
                  <button
                    type="button"
                    class="btn-close ct_close_position_right12"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div class="modal-body pe-0">
                  <section class="ct_signup_main py-3">
                    <div class="container-fluid">
                      <div class="row align-items-center">
                        <div class="col-xxl-4 col-xl-4 col-lg-4 mb-4 mb-lg-0 d-none d-lg-block">
                          <div class="ct_signup_left_img">
                            <img
                              src="../assets/img/you_will_learn_img.png"
                              alt=""
                            />
                          </div>
                        </div>
                        <div class="col-xxl-8 col-xl-8 col-lg-8 mb-4 mb-lg-0">
                          <div class="ct_signup_right_content px-5 ct_custom_scroll">
                            <div class="ct_signup_logo mb-3">
                              <img src="../assets/img/Nuvio_logo.png" alt="" />
                            </div>
                            <div class="mt-0 text-center">
                              <h2 class="ct_fs_32  mb-2 ct_darkblue_text">
                                Password Reset
                              </h2>
                              <p
                                class="mb-0 ct_darkblue_text"
                                style={{ maxWidth: "433px" }}
                              >
                                Code sent to johnpeter@gmail.com. Check your
                                inbox and enter it below to reset your password.
                              </p>
                            </div>
                            <form action="" class="mt-4">
                              <div class="row">
                                <div class="col-md-12">
                                  <div class="ct_otp_input">
                                    <div>
                                      <input
                                        type="number"
                                        class="form-control ct_input"
                                      />
                                    </div>
                                    <div>
                                      <input
                                        type="number"
                                        class="form-control ct_input"
                                      />
                                    </div>
                                    <div>
                                      <input
                                        type="number"
                                        class="form-control ct_input"
                                      />
                                    </div>
                                    <div>
                                      <input
                                        type="number"
                                        class="form-control ct_input"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="text-center mt-4">
                                <a
                                  data-bs-target="#ct_set_new_pass_modal"
                                  data-bs-toggle="modal"
                                  class="ct_yellow_btn w-100"
                                >
                                  Continue{" "}
                                </a>
                              </div>
                              <p class="mb-0 text-center mt-3">
                                Didn’t receive the email?{" "}
                                <a href="#" class="ct_orange_text">
                                  {" "}
                                  Click to resend
                                </a>
                              </p>
                            </form>
                            <div class="ct_back_login_text text-center mt-3">
                              <a
                                data-bs-target="#ct_login_modal"
                                data-bs-toggle="modal"
                                class="mb-0 ct_darkblue_text"
                              >
                                <i class="fa-solid fa-arrow-left"></i> Back to
                                Log in
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>
          {/*  ct_reset_pass_modal_modal modal  E */}

          {/*  ct_set_new_pass_modal modal  S */}
          <div
            class="modal fade ct_large_modal_width   "
            id="ct_set_new_pass_modal"
            tabindex="-1"
            aria-labelledby="ct_set_new_pass_modalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header border-0 p-0 pb-2">
                  <button
                    type="button"
                    class="btn-close ct_close_position_right12"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div class="modal-body ">
                  <section class="ct_signup_main py-3">
                    <div class="container-fluid">
                      <div class="row align-items-center">
                        <div class="col-xxl-4 col-xl-4 col-lg-4 mb-4 mb-lg-0 d-none d-lg-block">
                          <div class="ct_signup_left_img">
                            <img
                              src="../assets/img/set_new_pass_img.png"
                              alt=""
                            />
                          </div>
                        </div>
                        <div class="col-xxl-8 col-xl-8 col-lg-8 mb-4 mb-lg-0 mx-auto">
                          <div class="ct_signup_right_content px-5 ct_custom_scroll">
                            <div class="ct_signup_logo mb-3">
                              <img src="../assets/img/Nuvio_logo.png" alt="" />
                            </div>
                            <div class="mt-0 text-center">
                              <h2 class="ct_fs_32  mb-2 ct_darkblue_text">
                                Set New Password
                              </h2>
                              <p class="mb-0 ct_darkblue_text">
                                Enter your new password below. Make sure it’s
                                strong and unique to keep your account secure.
                              </p>
                            </div>
                            <form action="" class="mt-4">
                              <div class="row">
                                <div class="col-md-12">
                                  <div class="form-group mb-3">
                                    <label
                                      for=""
                                      class="mb-2 d-block ct_darkblue_text"
                                    >
                                      Password
                                    </label>
                                    <div class="position-relative">
                                      <input
                                        type="text"
                                        class="form-control ct_input pe-5"
                                        placeholder="Password"
                                      />
                                      <i class="fa-solid fa-eye ct_show_eye"></i>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-12">
                                  <div class="form-group mb-3">
                                    <label
                                      for=""
                                      class="mb-2 d-block ct_darkblue_text"
                                    >
                                      Confirm Password
                                    </label>
                                    <div class="position-relative">
                                      <input
                                        type="text"
                                        class="form-control ct_input pe-5"
                                        placeholder="Confirm password"
                                      />
                                      <i class="fa-solid fa-eye ct_show_eye"></i>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="text-center mt-4">
                                <a href="#" class="ct_yellow_btn w-100">
                                  Reset Password{" "}
                                </a>
                              </div>
                            </form>
                            <div class="ct_back_login_text text-center mt-3">
                              <a
                                data-bs-target="#ct_login_modal"
                                data-bs-toggle="modal"
                                class="mb-0 ct_darkblue_text"
                              >
                                <i class="fa-solid fa-arrow-left"></i> Back to
                                Log in
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>

          <div style={{ height: "100px" }}></div>
        </>
      );
      }}
      {/*  ct_set_new_pass_modal modal  E */}
    </MenuLayout>
  );
};
